import * as langs from "../constants/langs"
import * as request from "../utils/request"
import * as helper from "../utils/helper"
import * as uuid from "../utils/uuid"

const commonParams = {
  pfkey: "pfkey",
  from_h5: 1,
  r: Math.random()
}

export function initMqqJsApi() {
  if (window.mqq) {
    return Promise.resolve(window.mqq)
  } else {
    return request.getScript(langs.MQQ_JSAPI_URL).then(() => {
      return window.mqq
    })
  }
}

function getJSapiTokenId() {
  //qb充值需要校验这个
  if (window._SERVER_DATA && window._SERVER_DATA["authInfo"] && window._SERVER_DATA["authInfo"]["token_id"]) {
    return `jsapi_token_id=${window._SERVER_DATA["authInfo"]["token_id"]}`
  }

  return ""
}

/**
 * 调用手Q接口http://mqq.oa.com/api.html#js-mqq-tenpay-rechargeQb
 * @param params
 * @returns {Promise<any>}
 */
export function rechargeQB(params) {
  return new Promise((resolve, reject) => {
    initMqqJsApi().then(mqq => {
      let data = {
        offerId: params.offerId,
        userId: params.openid.toString(),
        channel: "",
        unit: "个",
        saveValue: params.quantity,
        aid: params.aid,
        numberVisible: true,
        provideUin: params.provideUin.toString(),
        provideType: params.sessionId //值为uin或者openid,因此可以用登陆态的sessionid
      }

      let token = getJSapiTokenId()

      if (token) {
        data.payload = token
      }

      data.payload = getJSapiTokenId()

      mqq.tenpay.rechargeQb(data, result => {
        if (result.resultCode == 0) {
          resolve(result)
        } else {
          reject(result)
        }
      })
    })
  })
}

/**
 * 选择手Q联系人,默认好友
 * @param params
 */
export function selectMqqContact(params) {
  return new Promise((resolve, reject) => {
    initMqqJsApi().then(mqq => {
      mqq.data.getFriendInfo(
        {
          title: "选择好友",
          acceptType: 16 || params.type,
          isMulti: true,
          limitNum: 1
        },
        res => {
          if (res.friends && res.friends.length > 0) {
            resolve(res.friends[0])
          } else {
            reject(res)
          }
        }
      )
    })
  })
}

/**
 * qq钱包绑卡
 * @param params
 */
export function bindQQWalletCard(params) {
  return new Promise((resolve, reject) => {
    initMqqJsApi().then(mqq => {
      mqq.tenpay.openTenpayView(
        {
          userId: params.openid,
          viewTag: "bindNewCard",
          bargainor_id: params.bargainorId,
          app_id: params.appId,
          channel: "sdk",
          appInfo: params.appInfo
        },
        res => {
          if (res.resultCode == 0) {
            resolve()
          } else {
            reject(res.retmsg)
          }
        }
      )
    })
  })
}

/**
 * 开通包月服务列表
 * @param params
 * @return {Promise}
 */
export function rechargeGameCurrency(params) {
  return new Promise((resolve, reject) => {
    initMqqJsApi().then(mqq => {
      let data = {
        offerId: params.offerId,
        userId: params.userId.toString(),
        zoneId: params.zoneId.toString() || "1",
        channel: "",
        saveValue: params.saveValue.toString(),
        numberVisible: params.numberVisible || true,
        isCanChange: params.isCanChange || false,
        aid: params.aid || "",
        remark: params.remark || "",
        provideUin: params.provideUin.toString(),
        provideType: params.provideType
      }

      if (params.discountId) {
        data.discountId = params.discountId
      }

      let token = getJSapiTokenId()

      if (token) {
        data.payload = token
      }

      mqq.tenpay.rechargeGameCurrency(data, result => {
        if (result.resultCode == 0) {
          resolve(result)
        } else {
          reject(result)
        }
      })
    })
  })
}

/**
 * 开通包月服务列表
 * @param params
 * @return {Promise}
 */
export function openService(params) {
  return new Promise((resolve, reject) => {
    initMqqJsApi().then(mqq => {
      let data = {
        offerId: params.offerId,
        userId: params.userId.toString(),
        serviceCode: params.serviceCode,
        serviceName: params.serviceName,
        channel: params.channel || "",
        unit: params.unit || "月",
        openMonth: params.openMonth || "",
        isCanChange: params.isCanChange || false,
        aid: params.aid,
        remark: params.remark,
        provideUin: params.provideUin.toString(),
        provideType: params.provideType //值为uin或者openid,因此可以用登陆态的sessionid
      }

      if (params.discountId) {
        data.discountId = params.discountId
      }

      mqq.tenpay.openService(data, result => {
        if (result.resultCode == 0) {
          resolve(result)
        } else {
          reject(result)
        }
      })
    })
  })
}

/**
 * 手Q iap 支付接口
 * @param params
 * @return {Promise}
 */
export function iapPay(params) {
  return new Promise((resolve, reject) => {
    let appremark = []
    appremark.push(`aid=${params.aid}`)

    initMqqJsApi().then(mqq => {
      let data = {
        apple_pay_source: params.apple_pay_source,
        qq_product_id: "",
        qq_product_name: params.qq_product_name,
        app_id: params.app_id,
        pf: params.pf,
        pfkey: "pfKey",
        product_id: params.product_id,
        product_type: params.product_type || 4,
        quantity: 1,
        is_deposit_game_coin: 0,
        pay_item: params.pay_item,
        var_item: encodeURIComponent(appremark.join("~"))
      }

      mqq.pay.pay(data, resultCode => {
        if (resultCode == 0) {
          resolve(resultCode)
        } else {
          reject(resultCode)
        }
      })
    })
  })
}

/**
 * 发送手Q消息
 * @param params
 */
export function shareMessage(params) {
  return new Promise((resolve, reject) => {
    initMqqJsApi().then(mqq => {
      mqq.ui.shareMessage(
        {
          title: params.title,
          desc: params.desc,
          share_type: params.shareType || 0,
          share_url: params.shareURL,
          image_url: params.imageURL,
          back: true,
          puin: "3042703080",
          sourceName: "腾讯充值",
          toUin: params.uin || "",
          uinType: params.uin ? 0 : ""
        },
        result => {
          if (result.retCode == 0) {
            resolve(result)
          } else {
            reject(result)
          }
        }
      )
    })
  })
}

/**
 * 查询 IAP 服务列表
 * @params 参数
 * pf
 * 登录态
 * service_code 大写
 */
export function getMpInfo(params) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)

    let apiParams = {
      pay_method: "iap",
      webversion: "h5_mobileqqV0.1",
      zoneid: 1,
      session_token: uuid.generate(),
      ...params.loginState,
      pf: params.pf
    }

    let data = helper.extend(apiParams, commonParams)

    request
      .ajax({
        url: "//" + env + `api.unipay.qq.com/v1/r/${params.offerId}/mobile_mp_info`,
        data,
        type: "post"
      })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function setOnMqqShareHandler(callback) {
  initMqqJsApi().then(mqq => {
    mqq.ui.setOnShareHandler(type => {
      let data = callback(type)
      shareMessageInQQ(data)
    })
  })
}

export function showShareMenu() {
  return initMqqJsApi().then(mqq => {
    mqq.ui.showShareMenu()
  })
}

export function shareMessageInQQ(params) {
  initMqqJsApi().then(() => {
    let data = {
      share_type: params.type || 0,
      title: params.title,
      desc: params.desc,
      share_url: params.url || location.href,
      image_url: params.img,
      back: true
    }
    if (mqq.compare("5.4") != 0) {
      //5.4不能增加公众号显示，会导致程序crash
      data.puin = "3042703080"
      data.sourceName = "腾讯充值"
    }
    mqq.ui.shareMessage(data)
  })
}

export function getUserInfo() {
  return new Promise(resolve => {
    initMqqJsApi().then(() => {
      mqq.data.getUserInfo(result => {
        resolve(result)
      })
    })
  })
}

export function compareVersion(a, b) {
  var i, l, r, len
  a = String(a).split(".")
  b = String(b).split(".")
  for (i = 0, len = Math.max(a.length, b.length); i < len; i++) {
    l = (isFinite(a[i]) && Number(a[i])) || 0
    r = (isFinite(b[i]) && Number(b[i])) || 0
    if (l < r) {
      return -1
    } else if (l > r) {
      return 1
    }
  }
  return 0
}

export function isNewWeiXin() {
  var ua = navigator.userAgent,
    REGEXP_WEIXIN = /\bMicroMessenger\/([\d\.]+)/,
    m = ua.match(REGEXP_WEIXIN),
    minVersion = "6.5.6" //此版本后拉起手Q用新api
  // 企业微信没有封堵 schema...
  var isWxWork = /\bwxwork\/([\d\.]+)/.test(ua)

  if (m && m[0] && m[1]) {
    if (compareVersion(m[1], minVersion) >= 0) {
      return !isWxWork
    } else {
      return false
    }
  } else {
    return false
  }
}

export function wxCallQQ(url) {
  WeixinJSBridge &&
    WeixinJSBridge.invoke(
      "launchApplication",
      {
        schemeUrl: url //需要被拉起第三方 APP 能处理的自定义 scheme URL
      },
      function () {
        //alert(JSON.stringify(res))
      }
    )
}

export function callQQ(url) {
  url = "mqqapi://forward/url?src_type=web&version=1&url_prefix=" + btoa(url) + "&t=" + new Date().getTime()
  //   location.href = "https://ti.qq.com/open_qq/index.html?url=" + encodeURIComponent(url)

  if (isNewWeiXin()) {
    if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
      wxCallQQ(url)
    } else {
      if (document.addEventListener) {
        document.addEventListener(
          "WeixinJSBridgeReady",
          function () {
            wxCallQQ(url)
          },
          false
        )
      } else if (document.attachEvent) {
        document.attachEvent("WeixinJSBridgeReady", function () {
          wxCallQQ(url)
        })
        document.attachEvent("onWeixinJSBridgeReady", function () {
          wxCallQQ(url)
        })
      }
    }
  } else {
    location.href = url
  }
}

export function closeWebview() {
  initMqqJsApi().then(mqq => {
    mqq.ui.closeWebViews({
      mode: 1,
      exclude: false
    })
  })
}
